var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13h5v-1h-5v1ZM16.5 10h-1v1.5h1V10ZM15.5 15h1v-1.5h-1V15Z",
    fill: "#FD7E60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6h-7.586a1 1 0 0 1-.707-.293l-1.414-1.414A1 1 0 0 0 10.086 4H4.5c-1.11 0-1.99-.11-1.99 1h7.16a1 1 0 0 1 .698.283l1.473 1.434A1 1 0 0 0 12.54 7H20.5a1 1 0 0 1 1 1v9h1V8c0-1.11-.89-2-2-2ZM2.5 17c0 1.11.89 2 2 2h16c1.11 0 2 .11 2-1h-18a1 1 0 0 1-1-1V6h-.99L2.5 17Z",
    fill: "#FD7E60"
  })));
};
export default SvgFolder;